/* eslint-disable no-nested-ternary */
import React, { useState } from 'react';
import { Button } from 'reactstrap';
import { ADD_EDIT_CONSTANT } from 'utils/constants';
import { couponConstants } from 'pages/OfferCoupons/constants';
import { IoMdAdd } from 'react-icons/io';
import DebounceTextInput from 'components/DebounseTextInput';
import OfferCouponsTable from '../OfferCouponsTable';
import DeletedOfferCouponsTable from '../DeletedOfferCouponsTable';
import ExpiredOfferCouponsTable from '../ExpiredOfferCouponsTable';
import InactiveOfferCouponsTable from '../InactiveOfferCouponsTable';

const CouponSearch = ({ tabType = 'All' }) => {
  const [searchString, setSearchString] = useState('');
  const [showAddRecord, setAddRecord] = useState({
    status: false,
    row: '',
    type: ADD_EDIT_CONSTANT.ADD,
  });
  const toggleAddRecord = (row = '', type = ADD_EDIT_CONSTANT.ADD) => {
    setAddRecord({ status: !showAddRecord.status, row, type });
  };

  const handleClickEdit = (val, type) => {
    toggleAddRecord(val, type);
  };
  const handleChange = (value) => {
    setSearchString(value);
  };
  return (
    <>
      {' '}
      <DebounceTextInput
        onInputChange={handleChange}
        delay={500} // Set your desired delay in milliseconds
        value={searchString}
        placeholder="Search by Coupons"
        positionRight="60px"
        positionTop="-59px"
      />
      <Button
        color="primary"
        className="text-nowrap p-0 mt-sm-0 position-absolute rounded-btn rounded-circle d-flex align-items-center justify-content-center coupon-add-btn"
        size="sm"
        onClick={toggleAddRecord}
      >
        <IoMdAdd color="#fff" size={20} />
      </Button>
      {/* <FSBModal
        size="xl"
        title={`${
          showAddRecord.type === ADD_EDIT_CONSTANT.EDIT
            ? showAddRecord.type
            : ADD_EDIT_CONSTANT.ADD
        } Coupon`}
        closeButtonLabel=""
        confirmButtonLabel=""
        message=""
        open={showAddRecord.status}
        toggleAlert={toggleAddRecord}
        onClose={toggleAddRecord}
        modalClass="right-drawer right-drawer-details"
      >
        <AddEditOfferCoupon
          currentRow={showAddRecord.row}
          type={showAddRecord.type}
          drawerToggle={toggleAddRecord}
        />
      </FSBModal> */}
      {tabType === couponConstants.ALL ? (
        <OfferCouponsTable
          searchString={searchString}
          //   filterValue={filterValue}
          handleClickEdit={handleClickEdit}
          showAddRecord={showAddRecord}
          setAddRecord={setAddRecord}
        />
      ) : tabType === couponConstants.EXPIRED ? (
        <ExpiredOfferCouponsTable
          searchString={searchString}
          //   filterValue={filterValue}
          handleClickEdit={handleClickEdit}
          showAddRecord={showAddRecord}
          setAddRecord={setAddRecord}
        />
      ) : tabType === couponConstants.INACTIVE ? (
        <InactiveOfferCouponsTable
          searchString={searchString}
          //   filterValue={filterValue}
          handleClickEdit={handleClickEdit}
          showAddRecord={showAddRecord}
          setAddRecord={setAddRecord}
        />
      ) : (
        <DeletedOfferCouponsTable
          searchString={searchString}
          //   filterValue={filterValue}
          handleClickEdit={handleClickEdit}
          showAddRecord={showAddRecord}
          setAddRecord={setAddRecord}
        />
      )}
    </>
  );
};

export default CouponSearch;
